import { axiosInstance } from 'utils/AxiosInstance';
import { API_PATHS } from 'utils/constants';

interface SignupData {
  email: string;
  password: string;
  phone: string;
  name: string;
  allow_policy: boolean;
  allow_mailing: boolean;
  organization: string;
  language: string;
}

  export const signupUsingInvitation = async (signupData: SignupData) => {
  return await axiosInstance.post(API_PATHS.PRIVATE_AREA_UPDATE, signupData);
};
